import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  UserGroupIcon,
  EnvelopeIcon,
  DocumentArrowUpIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { FaChartPie, FaEnvelope, FaGlobe, FaFileImport, FaCog, FaHome, FaRobot } from 'react-icons/fa';

interface LayoutProps {
  children: React.ReactNode;
}

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  { name: 'Email Templates', href: '/email-templates', icon: EnvelopeIcon },
  { name: 'Import Data', href: '/import', icon: DocumentArrowUpIcon },
  { name: 'Settings', href: '/settings', icon: Cog6ToothIcon },
];

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 w-64 bg-white shadow-lg">
        <div className="flex h-16 items-center justify-center border-b border-gray-200">
          <h1 className="text-xl font-bold text-primary-600">AI Leads Manager</h1>
        </div>
        <nav className="mt-5 px-2 space-y-1">
          <Link
            to="/"
            className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${
              location.pathname === '/' ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <FaHome className="mr-3 h-5 w-5" />
            Dashboard
          </Link>
          <Link
            to="/email-templates"
            className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${
              location.pathname === '/email-templates' ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <FaEnvelope className="mr-3 h-5 w-5" />
            Email Templates
          </Link>
          <Link
            to="/import"
            className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${
              location.pathname === '/import' ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <FaFileImport className="mr-3 h-5 w-5" />
            Import Data
          </Link>
          <Link
            to="/websites"
            className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${
              location.pathname === '/websites' ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <FaGlobe className="mr-3 h-5 w-5" />
            Websites
          </Link>
          <Link
            to="/chatbots"
            className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${
              location.pathname === '/chatbots' ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <FaRobot className="mr-3 h-5 w-5" />
            Chatbots
          </Link>
          <Link
            to="/settings"
            className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${
              location.pathname === '/settings' ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <FaCog className="mr-3 h-5 w-5" />
            Settings
          </Link>
        </nav>
      </div>

      {/* Main content */}
      <div className="pl-64">
        <main className="py-6">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout; 